import React, { useState } from "react";

import { Flex, Icon, Link } from "components";

export type AlertBannerProps = {
  className?: string;
  closeable?: boolean;
  dataTestId?: string;
  description?: string | React.ReactNode;
  iconName?: string;
  iconSize?: number;
  iconAlign?: "start" | "center" | "end";
  title?: string;
  headingSize?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  gap?: number;
  type?: "normal" | "warning" | "info" | string;
  link?: boolean;
  linkText?: string;
  onClick?: () => void;
  onClose?: () => void;
};

export const AlertBanner = ({
  className,
  closeable = false,
  dataTestId,
  description,
  iconName,
  iconSize = 32,
  iconAlign = "center",
  title,
  headingSize = "h4",
  gap = 16,
  type = "normal",
  link,
  linkText,
  onClick = () => {},
  onClose = () => {},
}: AlertBannerProps) => {
  const [hidden, setHidden] = useState(false);
  const HeadingSize = headingSize as keyof JSX.IntrinsicElements;
  const isHexColor = type?.startsWith("#");

  const handleClose = () => {
    setHidden(true);
    onClose();
  };

  const handleButtonClick = () => {
    onClick();
  };

  return hidden ? null : (
    <div className={`alert-banner ${type} ${className}`} data-testid={dataTestId} style={isHexColor ? { backgroundColor: type } : undefined}>
      <Flex className="width-100" gap={8} align={iconAlign}>
        {iconName && <Icon className="banner-icon" iconName={iconName} size={iconSize} />}
        <Flex className="width-100" vertical gap={gap}>
          {title && <HeadingSize>{title}</HeadingSize>}
          {description && typeof description === "string" ? <p className="margin-top-0 margin-bottom-0">{description}</p> : <>{description}</>}
          {link && <Link onClick={handleButtonClick}>{linkText}</Link>}
        </Flex>
      </Flex>
      {closeable && <Icon className="pointer" iconName="tabler/x" onClick={handleClose} />}
    </div>
  );
};
